import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Dropdown, Popup, Icon} from 'semantic-ui-react';
import {getNumericValue} from '../../../common/util/fieldsValidation';

const warehouses = ['CPD', 'TMP', 'LBR'];

class CpdKpi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'warehousesSelected': warehouses,
    };
  }

  getWarehouses() {
    return warehouses.map((warehouse) => {
      return {'text': warehouse, 'value': warehouse};
    });
  }

  changeWarehouse(value) {
    this.setState({'warehousesSelected': value});
  }

  getLinesNumberByWarehouse() {
    const {warehousesSelected} = this.state;
    const {inventoryStatus} = this.props;
    const linesCPD = inventoryStatus.linesCPD || 0;
    const linesTMP = inventoryStatus.linesTMP || 0;
    const linesLBR = inventoryStatus.linesLBR || 0;

    let totalsLines = 0;
    if (warehousesSelected.includes(warehouses[0])) {
      totalsLines += linesCPD;
    }
    if (warehousesSelected.includes(warehouses[1])) {
      totalsLines += linesTMP;
    }
    if (warehousesSelected.includes(warehouses[2])) {
      totalsLines += linesLBR;
    }
    return getNumericValue(totalsLines, 0);
  }

  getAmountByWarehouse() {
    const {warehousesSelected} = this.state;
    const {inventoryStatus} = this.props;
    const amountCPD = inventoryStatus.amountCPD || 0;
    const amountTMP = inventoryStatus.amountTMP || 0;
    const amountLBR = inventoryStatus.amountLBR || 0;

    let totalsAmount = 0;
    if (warehousesSelected.includes(warehouses[0])) {
      totalsAmount += amountCPD;
    }
    if (warehousesSelected.includes(warehouses[1])) {
      totalsAmount += amountTMP;
    }
    if (warehousesSelected.includes(warehouses[2])) {
      totalsAmount += amountLBR;
    }
    return getNumericValue(totalsAmount, 2);
  }

  getAmountByType(type) {
    const {warehousesSelected} = this.state;
    const {amountDetail} = this.props;

    let totalsAmount = 0;
    if (warehousesSelected.includes(warehouses[0])) {
      totalsAmount += amountDetail[`amount${type}InCPD`];
    }
    if (warehousesSelected.includes(warehouses[1])) {
      totalsAmount += amountDetail[`amount${type}InTMP`];
    }
    if (warehousesSelected.includes(warehouses[2])) {
      totalsAmount += amountDetail[`amount${type}InLBR`];
    }
    return totalsAmount;
  }

  getAmountDetail() {
    const partsTotal = this.getAmountByType('Parts');
    const accessoriesTotal = this.getAmountByType('Acc');
    const lubricantsTotal = this.getAmountByType('Lub');
    const suppliesTotal = this.getAmountByType('Supplies');
    const logisticTotal = this.getAmountByType('Logistic');
    const total =
      partsTotal +
      accessoriesTotal +
      lubricantsTotal +
      suppliesTotal +
      logisticTotal;

    return (
      <div>
        <div>
          Repuestos: {'$'}
          {getNumericValue(partsTotal || 0, 2)}
        </div>
        <div>
          Accesorios: {'$'}
          {getNumericValue(accessoriesTotal || 0, 2)}
        </div>
        <div>
          Lubricantes: {'$'}
          {getNumericValue(lubricantsTotal || 0, 2)}
        </div>
        <div>
          Insumos: {'$'}
          {getNumericValue(suppliesTotal || 0, 2)}
        </div>
        <div>
          Logistica: {'$'}
          {getNumericValue(logisticTotal || 0, 2)}
        </div>
        <div>
          Total: {'$'}
          {getNumericValue(total || 0, 2)}
        </div>
      </div>
    );
  }

  render() {
    const {warehousesSelected} = this.state;
    const {loadingInventoryStatus} = this.props;
   
    return (
      <Card raised fluid className='primary-content'>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column className='gray-bg inventory-status-container'>
              <div className='title-bar'>
                <div className='title'>
                  <h4>Número de líneas con stock en:</h4>
                  <Dropdown
                    selection
                    className='warehouses'
                    options={this.getWarehouses()}
                    value={warehousesSelected}
                    multiple
                    disabled={loadingInventoryStatus}
                    onChange={(e, {value}) => this.changeWarehouse(value)}
                  />
                  <div className='title-bar-actions'>
                    <h3>{this.getLinesNumberByWarehouse()}</h3>
                  </div>
                </div>
              </div>
            </Grid.Column>
            <Grid.Column className='gray-bg inventory-status-container'>
              <div className='title-bar'>
                <div className='title'>
                  <h4>Monto en:</h4>
                  <Dropdown
                    selection
                    className='warehouses'
                    options={this.getWarehouses()}
                    value={warehousesSelected}
                    multiple
                    disabled={loadingInventoryStatus}
                    onChange={(e, {value}) => this.changeWarehouse(value)}
                  />
                  <div className='title-bar-actions'>
                    <h3>{'$'}{this.getAmountByWarehouse()}</h3>
                    <Popup
                      trigger={
                        <Icon link name='info circle' color='blue' size='big' />
                      }
                      on='click'
                      position='bottom left'
                      inverted
                    >
                      <div>{this.getAmountDetail()}</div>
                    </Popup>
                  </div>
                </div>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingInventoryStatus': state.cpd.loadingInventoryStatus,
    'inventoryStatus': state.cpd.inventoryStatus,
    'amountDetail': state.cpd.amountDetail,
  };
};

export default connect(mapStateToProps, {})(CpdKpi);
